import { ixMap } from './helpers.js';
import { pipe, splitEvery } from 'ramda';
import { generate } from 'shortid';

// Folkrace:
//
// Folkrace süsteem on sisluliselt punktitabel, kus kõikide katsete punktid liidetakse kokku.
// Ainuke erinevus tavalise punktitabeliga on see, et robotid jaotatakse viie kaupa
// gruppidesse ja iga grupp võistleb korraga. Igast grupist saab X number parimaid roboteid
// edasi. Kõik edasi saanud robotid jaotatakse omakorda grupidesse, kuid see kord sellise
// loogikaga, et tekiks viis gruppi, kus igaühes min 3 ja max 5 robtit. Kõigi gruppidega
// toimub täpselt sama võistlus nagu varem – grupp võistleb korraga ja teeb kõik oma katsed
// järjest ära, katsete punktid liidetakse kokku. Nende viie grupi võitjad paigutatakse
// finaalgruppi, millega toimub jälle sama süsteem. Viimase grupi paremusjärjestus on selle
// võistluse top 5 paremusjärjestus.

// Admini poolt sisestatavad muutujad:
//   - Katsete arv
//   - Mitu robotit saab esimese vooru gruppidest edasi teise vooru
//   - Ühe katse ajaline kestus

// Ajakava arvutades arvestada üheks timeslotiks ühe grupi kui terviku aeg kõikide katsete tegemiseks.

export const getFolkRace = (teams, competition, beginTimeInSeconds) => {
  const {
    // TOOD peaks panema eraldi parameetri!
    // rrtCompetitorsInGroupAdvancing: advancing,
    // TODO check this input param
    attemptsLimit,
    attemptMaxLengthInSeconds
  } = competition;

  // TODO check this input param
  let l = attemptMaxLengthInSeconds || 90;

  const groupSize = 5;

  let matches = [],
      lastEndTime;

  pipe(
    // split teams to groups of predefined groupSize
    splitEvery(groupSize),
    // iterate over groups
    ixMap((group, groupIx) => {
      let groupBeginTime = lastEndTime ? lastEndTime : beginTimeInSeconds;
      
      ixMap((team, teamIx) => {
        for (let attemptIx = 0; attemptIx < (attemptsLimit || 3); attemptIx +=1) {
          
          let bTime = groupBeginTime + (attemptIx * l);
          lastEndTime = bTime + l;

          // HARDCODED for Folkrace past 1st round
          // if (groupIx < 1 ) {
          //   if (teamIx < 4) {
          //     matches.push({
          //       matchId: generate(),
          //       group: 13 + groupIx + 1,
          //       attempt: attemptIx + 1,
          //       team: null,
          //       beginTime: bTime,
          //       endTime: lastEndTime,
          //       matchType: 'PLAYOFF'
          //     });
          //   }
          // }

          
          matches.push({
            matchId: generate(),
            group: groupIx + 1,
            attempt: attemptIx + 1,
            team: team,
            beginTime: bTime,
            endTime: lastEndTime
          });

        }
      }, group);
    })
  )(teams);

  return matches;
};



// WEBPACK FOOTER //
// ./src/private/admin/utils/scheduler/folkrace.js